export default __webpack_public_path__ + "static/media/IMG_5385.3bf1ff8c.PNG";